export default "__VITE_ASSET__417b8da1__"